"use strict";
'use client';
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var swr_hooks_1 = require("@l2p/swr-hooks");
var react_1 = require("react");
var react_onesignal_1 = __importDefault(require("react-onesignal"));
var ONE_SIGNAL_INIT = 'one-signal-init';
var OneSignalInit = function (_a) {
    var appId = _a.appId, safariWebId = _a.safariWebId;
    var _b = (0, swr_hooks_1.useCache)(), getDataFromCache = _b.getDataFromCache, setDataToCache = _b.setDataToCache;
    (0, react_1.useEffect)(function () {
        var init = getDataFromCache(ONE_SIGNAL_INIT);
        if (!init) {
            setDataToCache(ONE_SIGNAL_INIT, true);
            react_onesignal_1.default.init({
                appId: appId,
                safari_web_id: safariWebId,
                notifyButton: {
                    enable: false,
                },
            })
                .then(function () {
                setDataToCache(ONE_SIGNAL_INIT, true);
            })
                .catch(function () {
                setDataToCache(ONE_SIGNAL_INIT, false);
            });
        }
        /*eslint-disable-next-line*/
    }, [appId, safariWebId]);
    return null;
};
exports.default = OneSignalInit;
